export default {
  text_input: {
    note: {
      place_holder: 'Notitie...',
    },
  },
  buttons: {
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
};
